module.exports = __webpack_public_path__ + "static/media/moderna_angelito.438a1152.png";